import {
  removeExcludedNodes,
  removeIds,
  removeNodesWithoutAnswers,
  removeNonessentialProperties,
} from '../actionCardOperations'
import clone from '../clone'

/**
 * Prepare the Action Card JSON before incorporating it into the AI prompt
 * (remove extra data to minimize token usage).
 */
export function adjustActionCardForPrompt(actionCardsData: any) {
  let prepared = clone(actionCardsData)

  prepared = removeNodesWithoutAnswers(prepared)
  prepared = removeExcludedNodes(prepared)
  prepared = removeIds(prepared)
  prepared = removeNonessentialProperties(prepared)

  return prepared
}
